<template>
    <div class="relative mb-4">
        <label class="mb-1 block text-sm font-medium text-gray-700">
            {{ $t('page') }}
        </label>
        <button
            type="button"
            class="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            @click="open = !open"
        >
            <span :class="modelValue ? 'text-gray-900' : 'text-gray-400'">
                {{
                    modelValue
                        ? modelValue.title?.[activeLocale]
                        : $t('select_page')
                }}
            </span>
            <fa
                icon="fa-chevron-down"
                class="text-xs text-gray-400 transition-transform duration-150"
                :class="{ 'rotate-180': open }"
            />
        </button>

        <div
            v-if="open"
            class="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md border border-gray-200 bg-white shadow-lg"
        >
            <div
                v-for="page in pages"
                :key="page.id"
                class="flex cursor-pointer items-center justify-between border-b border-gray-100 px-3 py-2.5 last:border-0 hover:bg-gray-50"
                :class="{ 'bg-blue-50': modelValue?.id === page.id }"
                @click="select(page)"
            >
                <span class="text-sm font-medium text-gray-800">
                    {{ page.title?.[activeLocale] }}
                </span>
                <span class="ml-4 max-w-[45%] truncate text-xs text-gray-400">
                    /{{ page.slug?.[activeLocale] }}
                </span>
            </div>
        </div>

        <div
            v-if="open"
            class="fixed inset-0 z-10"
            @click="open = false"
        />
    </div>
</template>

<script setup lang="ts">
import { LocaleMap, Page } from '@builder/types'
import { ref } from 'vue'

const props = defineProps<{
    pages: Page[]
    modelValue: Page | null
    activeLocale: keyof LocaleMap
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', page: Page): void
}>()

const open = ref(false)

const select = (page: Page) => {
    emit('update:modelValue', page)
    open.value = false
}
</script>
